module.exports = __webpack_public_path__ + "static/video-remaker-slide-c1729eb333264c0e8b86be2e3cc03d00.jpg";